import { render, staticRenderFns } from "./loginLayoutNew.vue?vue&type=template&id=3f7a1cac&"
import script from "./loginLayoutNew.vue?vue&type=script&lang=js&"
export * from "./loginLayoutNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports